import styled from 'styled-components';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

export const PopupOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const PopupContainer = styled.div`
  background: white;
  padding: 24px;
  border-radius: 16px;
  width: 90%;
  max-width: 400px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const PopupTitle = styled.h2`
  font-size: 20px;
  font-weight: 600;
  margin: 0;
  text-align: left;
`;

export const ChecklistItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  font-size: 16px;
  cursor:pointer;
`;

export const CheckIcon = styled(CheckCircleIcon)`
  color: #4CAF50 !important;
  width: 20px !important;
  height: 20px !important;
`;

export const CrossIcon = styled(CancelIcon)`
  color: #D3D3D3 !important;
  width: 20px !important;
  height: 20px !important;
`;
